{
  "common": {
    "cancel": "取消",
    "save": "儲存",
    "delete": "刪除",
    "done": "完成",
    "edit": "編輯",
    "search": "搜尋",
    "loading": "載入中…",
    "yes": "是",
    "no": "否",
    "settings": "設定",
    "back": "返回",
    "close": "關閉",
    "open": "開啟",
    "copy": "複製",
    "restore": "還原",
    "untitled": "無標題",
    "create": "建立",
    "revoke": "撤銷",
    "never": "從未",
    "tryAgain": "重試",
    "reload": "重新載入",
    "update": "更新",
    "insert": "插入",
    "loadingShort": "載入中",
    "unknown": "未知",
    "sampleSentence": "敏捷的棕色狐狸"
  },
  "sidebar": {
    "views": "檢視",
    "tags": "標籤",
    "edit": "編輯",
    "done": "完成",
    "account": "帳號",
    "newNote": "新增筆記",
    "editTag": "編輯標籤",
    "tagOptions": "標籤選項",
    "reorder": "重新排序 {{label}}",
    "showView": "顯示 {{label}}",
    "hideView": "隱藏 {{label}}",
    "editViews": "編輯檢視",
    "doneEditingViews": "完成編輯",
    "samplePeep": "Caliu 是…",
    "sampleQuiet": "一個讓你的思緒安住與呼吸的靜謐之地。"
  },
  "views": {
    "all": "所有筆記",
    "today": "今天",
    "todo": "待辦",
    "pinned": "已釘選",
    "untagged": "無標籤",
    "thisWeek": "本週",
    "shared": "我分享的",
    "sharedWithMe": "分享給我的",
    "attachments": "附件",
    "trash": "垃圾桶",
    "archive": "封存"
  },
  "noteList": {
    "empty": "還沒有筆記",
    "emptySubtitle": "建立第一則筆記，開始使用。",
    "untitled": "無標題",
    "selectNote": "選擇一則筆記",
    "selectNoteHint": "從清單中選擇一則筆記，或建立新的筆記。",
    "selectRestoreOrDelete": "選擇一則筆記以還原或永久刪除",
    "selectSharedToView": "選擇一則分享的筆記來檢視",
    "searchPlaceholder": "搜尋筆記…",
    "selectNotes": "選取筆記",
    "openSidebar": "開啟側邊欄",
    "cancelSelection": "取消選取",
    "clearSelection": "清除選取",
    "emptyTrash": "清空垃圾桶",
    "newNote": "新增筆記",
    "noteCount_one": "{{count}} 則筆記",
    "noteCount_other": "{{count}} 則筆記",
    "sortBy": "排序方式",
    "preview": "預覽",
    "modificationDate": "修改日期",
    "creationDate": "建立日期",
    "title": "標題",
    "manual": "手動",
    "newestOnTop": "最新在前",
    "small": "小",
    "medium": "中",
    "large": "大",
    "empty_pinned": "還沒有釘選的筆記",
    "empty_pinned_subtitle": "釘選筆記後，就能在這裡快速找到。",
    "empty_today": "今天還沒有編輯過",
    "empty_today_subtitle": "今天編輯過的筆記會出現在這裡。",
    "empty_todo": "還沒有待辦事項",
    "empty_todo_subtitle": "含有未完成任務的筆記會出現在這裡。",
    "empty_untagged": "所有筆記都有標籤",
    "empty_untagged_subtitle": "沒有標籤的筆記會出現在這裡。",
    "empty_thisWeek": "本週還沒有內容",
    "empty_thisWeek_subtitle": "過去 7 天編輯過的筆記會出現在這裡。",
    "empty_shared": "沒有分享的筆記",
    "empty_shared_subtitle": "你分享的筆記會出現在這裡。",
    "empty_attachments": "還沒有附件",
    "empty_attachments_subtitle": "含有圖片或檔案的筆記會出現在這裡。",
    "justNow": "剛剛",
    "minutesAgo": "{{count}} 分鐘前",
    "today": "今天",
    "yesterday": "昨天",
    "deletedOn": "已於 {{date}} 刪除",
    "newNoteShortcut": "新增筆記（{{shortcut}}）",
    "noContent": "沒有內容",
    "selectUnarchiveOrDelete": "選擇一則筆記以取消封存或刪除",
    "view": "檢視",
    "density": "密度",
    "exportAll": "全部匯出"
  },
  "editor": {
    "attachmentTooLarge": "這個檔案太大，無法附加。上限為 100 MB。",
    "placeholder": "開始書寫…",
    "noMatchingCommands": "沒有相符的指令",
    "newNote": "新筆記",
    "noResults": "沒有結果",
    "foldSection": "摺疊章節",
    "unfoldSection": "展開章節",
    "dragSection": "移動章節",
    "presenceLabel": "也在這裡: {{names}}"
  },
  "noteActions": {
    "pin": "釘選",
    "unpin": "取消釘選",
    "pinToTop": "釘選到最上方",
    "makeReadOnly": "設為唯讀",
    "makeEditable": "設為可編輯",
    "readOnlyNote": "唯讀筆記",
    "shareNote": "分享筆記",
    "share": "分享",
    "publiclyShared": "已公開分享",
    "privateNote": "私人筆記",
    "linkCreated": "已建立連結",
    "linkCreatedAndCopied": "已建立並複製連結",
    "linkRevoked": "已撤銷分享連結",
    "failedToCreateShareLink": "無法建立分享連結",
    "failedToRevokeShareLink": "無法撤銷分享連結",
    "thisNoteIsPrivate": "這則筆記是私人的。",
    "createPublicLink": "建立公開連結",
    "creatingLink": "正在建立連結…",
    "revokeLink": "撤銷連結",
    "revokingLink": "撤銷中…",
    "copyLink": "複製連結",
    "copyNoteId": "複製筆記 ID",
    "noteIdCopied": "已複製筆記 ID",
    "exportAs": "匯出為",
    "exportMarkdown": "Markdown",
    "exportPlainText": "純文字",
    "exportHtml": "HTML",
    "exportRtf": "RTF",
    "exportEpub": "ePub",
    "exportTextpack": "TextPack",
    "exportFailed": "匯出失敗",
    "viewHistory": "檢視歷史",
    "duplicate": "複製",
    "duplicateFailed": "無法複製筆記",
    "select": "選取",
    "delete": "刪除",
    "moveToTrash": "移到垃圾桶",
    "archive": "封存",
    "unarchive": "取消封存",
    "tags": "標籤",
    "addTag": "加入標籤",
    "noTagsYet": "還沒有標籤",
    "addTagFailed": "無法加入標籤",
    "removeTagFailed": "無法移除標籤"
  },
  "userMenu": {
    "theme": "主題",
    "typography": "字型",
    "language": "語言",
    "apiKeys": "API 金鑰",
    "devices": "裝置",
    "connectedApps": "已連接的應用程式",
    "help": "說明",
    "logOut": "登出",
    "defaultUserName": "Caliu 使用者",
    "editName": "編輯名稱",
    "nameLabel": "名稱",
    "namePlaceholder": "你的名稱",
    "upgradeToPro": "升級為 Caliu Pro",
    "replayOnboarding": "重看新手導覽",
    "logOutTitle": "要登出嗎？",
    "logOutBody": "你的筆記會留在本裝置上，仍可繼續閱讀和編輯。重新登入即可同步。",
    "logOutPending_one": "還有 {{count}} 項變更尚未同步。它會留在本裝置上，直到你重新登入。",
    "logOutPending_other": "還有 {{count}} 項變更尚未同步。它們會留在本裝置上，直到你重新登入。",
    "logOutKeep": "登出",
    "logOutAndRemove": "登出並刪除筆記"
  },
  "help": {
    "title": "說明中心",
    "searchPlaceholder": "搜尋說明文章",
    "noResults": "沒有符合搜尋的文章。",
    "offline": "離線時無法使用說明。下次連上網路時會自動載入。"
  },
  "fonts": {
    "uiFont": "介面字型",
    "body": "內文",
    "headings": "標題",
    "code": "程式碼",
    "sans": "無襯線",
    "serif": "襯線",
    "mono": "等寬",
    "editor": "編輯器",
    "ui": "介面",
    "reset": "重設為預設值"
  },
  "themes": {
    "light": "淺色",
    "dark": "深色",
    "system": "跟隨系統"
  },
  "languages": {
    "systemHint": "依你的裝置偵測",
    "names": {
      "en": "英文",
      "es": "西班牙文",
      "ca": "加泰隆尼亞文",
      "fr": "法文",
      "de": "德文",
      "it": "義大利文",
      "pt": "葡萄牙文",
      "nl": "荷蘭文",
      "ja": "日文",
      "zh-CN": "簡體中文",
      "ko": "韓文",
      "zh-TW": "繁體中文",
      "ru": "俄文"
    }
  },
  "bulkActions": {
    "pinSelected": "釘選所選",
    "unpinSelected": "取消釘選所選",
    "pin": "釘選",
    "addTag": "加入標籤",
    "filterTags": "篩選標籤…",
    "noTagsFound": "找不到標籤",
    "exportSelected": "匯出所選",
    "restoreSelected": "還原所選",
    "deletePermanently": "永久刪除",
    "moveToTrash": "移到垃圾桶",
    "archiveSelected": "封存所選",
    "unarchiveSelected": "取消封存所選",
    "exportingTitle": "正在匯出你的筆記",
    "exportingBody": "這可能需要一點時間。完成前請保持這個分頁開啟。",
    "exportingProgress": "{{done}} / {{total}}"
  },
  "commandPalette": {
    "placeholder": "搜尋筆記、標籤、指令…",
    "noResults": "找不到「{{query}}」的結果",
    "currentNote": "目前筆記",
    "navigation": "導覽",
    "notes": "筆記",
    "tags": "標籤",
    "newNote": "新增筆記",
    "allNotes": "所有筆記",
    "todaysNotes": "今天的筆記",
    "todo": "待辦",
    "pinnedNotes": "已釘選的筆記",
    "trash": "垃圾桶",
    "importNotes": "匯入筆記",
    "changeTheme": "更換主題",
    "keyboardShortcuts": "鍵盤快速鍵",
    "pinNote": "釘選筆記",
    "unpinNote": "取消釘選筆記",
    "restoreNote": "還原筆記",
    "copyShareLink": "複製分享連結",
    "makePrivate": "設為私人",
    "toggleFullscreen": "切換全螢幕",
    "noteInfo": "筆記資訊",
    "moveToTrash": "移到垃圾桶",
    "archiveNote": "封存筆記",
    "unarchiveNote": "取消封存筆記",
    "archive": "封存"
  },
  "noteHistory": {
    "title": "筆記歷史",
    "requiresConnection": "筆記歷史需要網路連線。",
    "reconnect": "請重新連上網路後再試一次。",
    "noHistory": "這則筆記還沒有歷史記錄。",
    "windowMerged": "5 分鐘內的編輯會合併為一筆記錄。",
    "selectVersion": "選擇要預覽的版本",
    "encrypted": "加密快照",
    "encryptedHint": "這個版本以端對端加密儲存。請開啟筆記以檢視目前的內容。",
    "restoreVersion": "要還原這個版本嗎？",
    "restoreVersionHint": "這會用 {{date}} 的版本取代目前的筆記內容。",
    "current": "目前",
    "created": "已建立",
    "trashed": "已刪除",
    "restored": "已還原",
    "edited": "已編輯"
  },
  "apiKeys": {
    "title": "API 金鑰",
    "empty": "還沒有 API 金鑰。",
    "emptyHint": "建立一組金鑰，開始使用 API。",
    "created": "建立於 {{date}}",
    "lastUsed": "上次使用：{{date}}",
    "revokeKey": "撤銷金鑰",
    "viewApiDocs": "檢視 API 文件",
    "newApiKey": "新增 API 金鑰",
    "apiKeyCreated": "已建立 API 金鑰",
    "createApiKey": "建立 API 金鑰",
    "copyHint": "請立即複製這組金鑰。之後將無法再次檢視。",
    "copyToClipboard": "複製到剪貼簿",
    "keyName": "金鑰名稱",
    "keyNamePlaceholder": "例如：我的指令碼、Zapier 整合",
    "createKey": "建立金鑰",
    "revokeKeyTitle": "撤銷 API 金鑰",
    "revokeKeyHint": "這會永久撤銷這組 API 金鑰。任何正在使用它的應用程式都會立即失去存取權。",
    "keyPrefix": "caliu_{{prefix}}…"
  },
  "connectedApps": {
    "title": "已連接的應用程式",
    "empty": "還沒有已連接的應用程式。",
    "emptyHint": "連接 Claude、ChatGPT 或其他 AI 助理，即可在聊天中使用你的筆記。操作方式請參閱說明中的「Caliu 與 AI」章節。",
    "connected": "連接於 {{date}}",
    "lastUsed": "上次使用：{{date}}",
    "revoke": "撤銷",
    "revokeTitle": "撤銷連接",
    "revokeHint": "這會撤銷 <strong>{{name}}</strong> 對你 Caliu 帳號的存取權，並刪除它使用的憑證。它會立即失去存取權。",
    "thisApp": "這個應用程式",
    "defaultScope": "mcp"
  },
  "noteStats": {
    "writing": "寫作",
    "metadata": "中繼資料",
    "words": "字數",
    "characters": "字元",
    "paragraphs": "段落",
    "readTime": "閱讀時間",
    "minutes": "{{count}} 分鐘",
    "tags": "標籤",
    "outgoingLinks": "連出連結",
    "backlinks": "反向連結",
    "created": "建立",
    "modified": "修改",
    "noteStatistics": "筆記統計",
    "identifier": "識別碼"
  },
  "inspector": {
    "tabInfo": "資訊",
    "tabOutline": "大綱",
    "tabHistory": "歷史",
    "dates": "日期",
    "noHeadings": "這則筆記沒有標題",
    "noBacklinks": "沒有筆記連到這裡",
    "noOutgoing": "這則筆記沒有連到任何內容",
    "noAttachments": "這則筆記沒有附件",
    "historyOffline": "版本歷史需要網路連線",
    "historyLoadMore": "載入更多"
  },
  "devices": {
    "title": "裝置",
    "offline": "你目前離線。",
    "offlineHint": "請連上網路以檢視你的裝置。",
    "noSessions": "找不到作用中的工作階段。",
    "thisDevice": "這台裝置",
    "lastUsed": "上次使用：{{date}}",
    "created": "建立於：{{date}}",
    "signOutCurrent": "在這台裝置上登出",
    "signOut": "登出",
    "confirmCurrentTitle": "要在這台裝置上登出嗎？",
    "confirmRevokeTitle": "要撤銷這台裝置嗎？",
    "confirmCurrentBody": "你會在這個瀏覽器中登出 Caliu，筆記也會從這台裝置移除。你可以隨時重新登入，筆記會從你的帳號回來。",
    "confirmRevokeBody": "這會立即讓該裝置登出。在你再次登入之前，該裝置上未同步的變更會留在原處。",
    "revoke": "撤銷"
  },
  "errorScreen": {
    "title": "發生問題",
    "defaultMessage": "發生非預期的錯誤。請試著重新載入頁面。"
  },
  "importModal": {
    "title": "匯入筆記",
    "dropToImport": "放開以匯入",
    "dropOrClick": "拖放檔案，或點選瀏覽",
    "removeFile": "移除檔案",
    "keepNote": "若要匯入 Google Keep，請匯出 Takeout ZIP，並直接上傳該壓縮檔。",
    "importedCount_one": "已匯入 <strong>{{count}}</strong> 則筆記",
    "importedCount_other": "已匯入 <strong>{{count}}</strong> 則筆記",
    "fromSource": "（來自 {{source}}）",
    "importing": "匯入中…",
    "importN": "匯入 {{count}} 個檔案",
    "importBtn": "匯入"
  },
  "share": {
    "shareNote": "分享筆記",
    "publiclySharedAria": "這則筆記已公開分享",
    "copyLink": "複製連結",
    "revokingLink": "撤銷中…",
    "revokeLink": "撤銷連結",
    "creatingLink": "正在建立連結…",
    "createPublicLink": "建立公開連結",
    "shareThisNotePublicly": "公開分享這則筆記",
    "thisNoteIsPrivate": "這則筆記是私人的。",
    "publiclyShared": "已公開分享",
    "privateNote": "私人筆記"
  },
  "shortcuts": {
    "searchPlaceholder": "搜尋快速鍵…",
    "pressNew": "請按下新的快速鍵…",
    "resetToDefault": "重設為預設值",
    "noMatches": "沒有符合「<strong>{{query}}</strong>」的快速鍵",
    "navigate": "瀏覽",
    "edit": "編輯",
    "closeAction": "關閉",
    "resetAll": "全部重設"
  },
  "tagEditor": {
    "icon": "圖示",
    "color": "顏色",
    "searchIcons": "搜尋圖示",
    "noIcons": "沒有符合的圖示",
    "categories": {
      "essentials": "常用",
      "work": "工作與科技",
      "ideas": "靈感與創作",
      "life": "人與家庭",
      "travel": "旅行與自然",
      "fun": "美食、健康與娛樂"
    }
  },
  "tagActions": {
    "pin": "釘選標籤",
    "unpin": "取消釘選標籤",
    "rename": "重新命名…",
    "renameTitle": "重新命名標籤",
    "renameConfirm": "重新命名",
    "renameHint": "每一則使用這個標籤的筆記都會更新，包括已封存的筆記和垃圾桶中的筆記。",
    "renamed": "標籤已重新命名",
    "nameInUse": "這個名稱已經有人在用",
    "invalidName": "標籤名稱只能使用字母、數字、空格、連字號和底線",
    "pinFailed": "無法更新標籤",
    "renameFailed": "無法重新命名標籤",
    "editAppearance": "編輯外觀"
  },
  "auth": {
    "appName": "Caliu",
    "or": "或",
    "email": "電子郵件",
    "emailPlaceholder": "you@example.com",
    "password": "密碼",
    "passwordPlaceholder": "密碼",
    "name": "名稱",
    "namePlaceholder": "你的名稱",
    "confirmPassword": "確認密碼",
    "newPassword": "新密碼",
    "confirmNewPassword": "確認新密碼",
    "signInSubtitle": "登入你的帳號",
    "createAccountSubtitle": "建立你的帳號",
    "forgotPassword": "忘記密碼？",
    "signingIn": "正在登入…",
    "signIn": "登入",
    "noAccount": "還沒有帳號嗎？",
    "signUp": "註冊",
    "haveAccount": "已經有帳號了嗎？",
    "creatingAccount": "正在建立帳號…",
    "createAccount": "建立帳號",
    "googleSignUpAria": "使用 Google 註冊",
    "signupClosedTitle": "目前暫停註冊",
    "signupClosedBody": "Caliu 目前是私人測試版。請到 caliuapp.com 加入候補名單，搶先體驗。",
    "joinWaitlist": "加入候補名單",
    "forgotTitle": "重設密碼",
    "forgotSubtitle": "輸入你的電子郵件，我們會寄送重設連結給你。",
    "sendResetLink": "寄送重設連結",
    "sending": "傳送中…",
    "checkYourEmail": "請查看你的電子郵件",
    "resetLinkSentPrefix": "如果 ",
    "resetLinkSentSuffix": " 已有帳號，我們已寄出密碼重設連結。連結會在 1 小時後失效。",
    "backToSignIn": "返回登入",
    "verifySentPrefix": "我們已將驗證連結寄到 ",
    "verifySentSuffix": "。點選連結即可啟用你的帳號。",
    "linkExpires10m": "連結會在 10 分鐘後失效。",
    "resending": "重新寄送中…",
    "resendEmail": "重新寄送郵件",
    "wrongEmail": "電子郵件不對嗎？",
    "goBack": "返回",
    "invalidResetLinkTitle": "重設連結無效",
    "invalidResetLinkBody": "這個連結無效或已過期。",
    "requestNewLink": "申請新的連結",
    "setNewPasswordTitle": "設定新密碼",
    "setNewPasswordHint": "請選擇一組強度足夠的密碼。",
    "updatingPassword": "更新中…",
    "updatePassword": "更新密碼",
    "localNotesTitle": "這部裝置上有筆記",
    "localNotesBody_one": "登入前你在這裡寫了 {{count}} 則筆記。要如何處理？",
    "localNotesBody_other": "登入前你在這裡寫了 {{count}} 則筆記。要如何處理？",
    "localNotesDelete": "刪除它們",
    "localNotesMerge": "加入我的帳號",
    "backToMyNotes": "返回我的筆記",
    "errorGoogleAuthFailed": "Google 登入失敗。請再試一次。",
    "errorInvalidToken": "驗證連結無效。請重新註冊。",
    "errorEmailTaken": "這個電子郵件已被使用。請登入。",
    "signInInstead": "改為登入該帳號",
    "errorIdentityTaken": "這個登入方式已綁定到另一個 Caliu 帳號。請登入該帳號。",
    "parkedNotesTitle": "來自其他帳號的筆記",
    "parkedNotesBody_one": "登入 {{email}} 可以把該帳號的筆記留在這台裝置上。換成其他帳號會清除這裡唯一的一則筆記，包括之後寫的內容。",
    "parkedNotesBody_other": "登入 {{email}} 可以把該帳號的筆記留在這台裝置上。換成其他帳號會清除這裡全部 {{count}} 則筆記，包括之後寫的內容。",
    "parkedNotesBodyNoEmail_one": "登入你登出的那個帳號可以把該帳號的筆記留在這台裝置上。換成其他帳號會清除這裡唯一的一則筆記，包括之後寫的內容。",
    "parkedNotesBodyNoEmail_other": "登入你登出的那個帳號可以把該帳號的筆記留在這台裝置上。換成其他帳號會清除這裡全部 {{count}} 則筆記，包括之後寫的內容。",
    "parkedNotesContinue": "繼續"
  },
  "connectors": {
    "wantsAccess": "想要存取 Caliu",
    "couldntLoad": "無法載入這個請求",
    "authorize": "授權",
    "keepHappeningHint": "如果這個狀況持續發生，請從你的 MCP 用戶端移除這個連接器，再重新加入。",
    "backToCaliu": "返回 Caliu",
    "askingPermissionPrefix": "正在要求權限，透過 Caliu 的 MCP 伺服器讀取及修改你的筆記和標籤。",
    "signedInAs": "已以 {{name}} 的身分登入。",
    "permissions": "權限",
    "deny": "拒絕",
    "allow": "允許"
  },
  "editorTypography": {
    "fontSize": "字型大小",
    "lineHeight": "行高",
    "paragraphSpacing": "段落間距"
  },
  "emptyState": {
    "cmdGlyph": "⌘",
    "ctrlGlyph": "Ctrl",
    "shiftGlyph": "Shift"
  },
  "floatingMenu": {
    "undo": "復原",
    "redo": "重做",
    "taskList": "任務清單",
    "bulletList": "項目符號清單",
    "orderedList": "編號清單",
    "blockQuote": "引言區塊",
    "separator": "分隔線",
    "insertTag": "插入標籤",
    "highlight": "螢光標示",
    "math": "公式",
    "removeHighlight": "移除螢光標示",
    "inlineCode": "行內程式碼",
    "codeBlock": "程式碼區塊",
    "insertTable": "插入表格",
    "insertImage": "插入圖片",
    "hideStyleBar": "隱藏樣式列",
    "attachFile": "附加檔案",
    "photoLibrary": "照片圖庫",
    "camera": "相機",
    "fromFile": "從檔案"
  },
  "imageDialog": {
    "title": "插入圖片",
    "tabUpload": "檔案",
    "tabUrl": "URL",
    "urlLabel": "圖片 URL",
    "urlPlaceholder": "https://example.com/image.jpg",
    "altLabel": "替代文字",
    "altPlaceholder": "描述這張圖片…",
    "previewAlt": "預覽",
    "changeImage": "更換圖片",
    "dropToInsert": "放開以插入",
    "dropOrClick": "拖放圖片，或點選瀏覽",
    "formats": "PNG、JPG、GIF、WebP",
    "insert": "插入圖片"
  },
  "linkDialog": {
    "editTitle": "編輯連結",
    "insertTitle": "插入連結",
    "textLabel": "文字",
    "textPlaceholder": "連結文字",
    "urlPlaceholder": "https://example.com",
    "removeLink": "移除連結",
    "openLink": "開啟連結",
    "editLink": "編輯連結"
  },
  "noteEditor": {
    "notFound": "找不到筆記。",
    "inTrashBanner": "這則筆記在垃圾桶裡。請先還原才能編輯。",
    "restore": "還原",
    "noContent": "這則筆記沒有內容。"
  },
  "noteHeader": {
    "noteInfo": "筆記資訊"
  },
  "table": {
    "deleteRow": "刪除列",
    "deleteTable": "刪除表格",
    "addRow": "新增列",
    "addRowAbove": "在上方新增列",
    "addColumn": "新增欄",
    "addColumnBefore": "在前方新增欄",
    "moveRowUp": "上移列",
    "moveRowDown": "下移列",
    "moveColumnLeft": "左移欄",
    "moveColumnRight": "右移欄",
    "deleteColumn": "刪除欄",
    "actions": "表格操作"
  },
  "syncIndicator": {
    "synced": "已同步",
    "pending_one": "{{count}} 項待同步",
    "pending_other": "{{count}} 項待同步",
    "offline": "離線",
    "offlinePending_one": "離線 · {{count}} 項待處理",
    "offlinePending_other": "離線 · {{count}} 項待處理",
    "syncing": "同步中...",
    "conflict_one": "{{count}} 個衝突",
    "conflict_other": "{{count}} 個衝突",
    "error": "同步錯誤",
    "syncedTooltip": "所有變更都已儲存",
    "pendingTooltip_one": "{{count}} 項變更等待同步",
    "pendingTooltip_other": "{{count}} 項變更等待同步",
    "offlineTooltip": "離線：重新連線後會同步變更",
    "offlinePendingTooltip_one": "離線：重新連線後會同步 {{count}} 項變更",
    "offlinePendingTooltip_other": "離線：重新連線後會同步 {{count}} 項變更",
    "syncingTooltip": "同步中...",
    "syncingPendingTooltip_one": "正在同步 {{count}} 項待處理的變更...",
    "syncingPendingTooltip_other": "正在同步 {{count}} 項待處理的變更...",
    "conflictTooltip_one": "{{count}} 則筆記有衝突的變更。點選以解決。",
    "conflictTooltip_other": "{{count}} 則筆記有衝突的變更。點選以解決。",
    "errorTooltip": "同步失敗，將會自動重試。",
    "conflictsTitle": "解決衝突",
    "local": "在此裝置上",
    "localTooltip": "僅儲存在此裝置上。登入後即可同步。"
  },
  "image": {
    "download": "下載圖片",
    "replace": "取代圖片",
    "remove": "移除圖片"
  },
  "sharePage": {
    "goToCaliu": "前往 Caliu",
    "noteNotFoundTitle": "找不到筆記",
    "somethingWentWrong": "發生問題",
    "lastUpdated": "上次更新：{{date}}",
    "tagline": "為思考者打造的筆記應用程式",
    "subtagline": "用 Markdown 寫作。隨處同步。思緒清晰。",
    "startWriting": "開始寫作",
    "signIn": "登入",
    "openInCaliu": "在 Caliu 中開啟",
    "adding": "新增中…",
    "addToSharedList": "加入我的分享清單",
    "notFoundSubtitle": "這個分享連結可能已過期或被撤銷。",
    "errorSubtitle": "無法載入這則筆記。請再試一次。"
  },
  "sharedView": {
    "loading": "正在載入分享的筆記…",
    "sharedWithYou": "分享給你的",
    "viewRaw": "檢視原始 Markdown",
    "viewRendered": "檢視排版後的筆記",
    "copyMarkdown": "複製 Markdown",
    "markdownCopied": "已複製 Markdown",
    "copyFailed": "複製失敗",
    "notLoadedYet": "這則筆記尚未載入完成",
    "linkCopied": "已複製連結",
    "actions": "筆記操作"
  },
  "sharedWithMe": {
    "title": "分享給我的",
    "removeFromList": "從清單中移除",
    "empty": "還沒有分享給我的筆記",
    "emptyHint": "開啟朋友傳來的 Caliu 分享連結，就會加到這裡。分享的筆記會在你的裝置之間同步。"
  },
  "trashView": {
    "empty": "垃圾桶是空的",
    "emptyHint": "刪除的筆記會出現在這裡",
    "retention": "垃圾桶中的筆記會在 30 天後永久刪除",
    "trash": "垃圾桶"
  },
  "fileAttachment": {
    "download": "下載檔案",
    "remove": "移除檔案"
  },
  "archiveView": {
    "archive": "封存",
    "empty": "封存是空的",
    "emptyHint": "封存的筆記會出現在這裡",
    "archivedOn": "已於 {{date}} 封存"
  },
  "pro": {
    "subtitle": "Caliu，毫無保留。",
    "features": [
      "無限筆記",
      "筆記版本歷史",
      "匯出 PDF、HTML、RTF、ePub 與批次匯出",
      "所有主題、字型和應用程式圖示",
      "支持 Caliu 的開發"
    ],
    "perMonth": "每月 {{price}}",
    "perWeek": "每週 {{price}}",
    "oneTime": "一次性付費 {{price}}",
    "perYear": "每年 {{price}}",
    "or": "或",
    "signInToSubscribe": "登入後訂閱",
    "accountRequired": "Caliu Pro 與你的帳號綁定，因此在所有裝置上都能使用。",
    "plansUnavailable": "無法載入訂閱方案。請檢查網路連線後再試一次。",
    "yearly": "年繳",
    "monthly": "月繳",
    "continue": "繼續",
    "bestValue": "最超值",
    "autoRenew": "{{amount}}。在取消前會自動續訂。可隨時取消。",
    "freeTrial": "免費試用 {{count}} 天",
    "billedSubtitle": "免費試用 {{count}} 天，之後按{{amount}}扣款。可隨時取消。",
    "startTrial": "開始免費試用",
    "upgradeSubtitle": "版本歷史、所有主題與字型、匯出等更多功能。",
    "upgradeNow": "立即升級",
    "thanks": "感謝你支持 Caliu！",
    "renewsOn": "{{date}} 續訂",
    "endsOn": "{{date}} 到期",
    "lifetime": "終身使用權",
    "lifetimePlan": "永久",
    "oneTimeNoRenewal": "一次性付款",
    "launchPrice": "首發價。之後將調漲至 {{price}}。",
    "buy": "購買",
    "oneTimeDisclosure": "{{amount}}。一次性付款，無需續訂。",
    "thanksMessage": "你的支持讓 Caliu 保持獨立與私密。",
    "manageSubscription": "管理訂閱",
    "contactUs": "有問題嗎？聯絡我們",
    "grandfatheredNote": "身為早期支持者，Caliu Pro 永遠屬於你，不需要續訂。",
    "webFootnote": "PDF 匯出目前還無法在網頁版使用。",
    "active": "使用中"
  },
  "find": {
    "placeholder": "在筆記中尋找",
    "matchCount": "{{current}}/{{total}}",
    "noResults": "沒有結果",
    "next": "下一個相符項目",
    "previous": "上一個相符項目",
    "close": "關閉"
  },
  "conflicts": {
    "description": "這則筆記在另一台裝置上被編輯過。請保留其中一個版本。",
    "yours": "你的版本",
    "theirs": "對方的版本",
    "step": "第 {{current}} 個，共 {{total}} 個",
    "keepYours": "保留你的",
    "keepTheirs": "保留對方的",
    "serverError": "無法載入另一個版本。",
    "done": "所有衝突都已解決。",
    "previous": "上一個衝突",
    "next": "下一個衝突",
    "copyOf": "{{title}} 的副本"
  },
  "onboarding": {
    "welcomeTitle": "歡迎使用 Caliu",
    "welcomeSubtitle": "一個讓你的思緒安住與呼吸的靜謐之地。",
    "getStarted": "開始使用",
    "magicTitle": "看著你的文字成形",
    "magicSubtitle": "你只要寫純文字，Caliu 會把它變成結構：任務、螢光標示，還有自動歸位的標籤。",
    "magicLearnMore": "學習 Markdown 基礎",
    "replay": "重播",
    "demoTitle": "海邊的夏天",
    "demoBody": "計劃在小鎮上過一個**慢步調的星期**。",
    "demoTask": "訂下那間小屋",
    "demoHighlight": "早餐==前==游泳",
    "demoTags": "#夏天 #計畫",
    "intentTitle": "你想在這裡放些什麼？",
    "intentSubtitle": "選幾個吧。你的第一則筆記和標籤已經在等你了。",
    "themeTitle": "選擇你的光",
    "themeSubtitle": "各式主題，呼應你寫作時的心境。",
    "proTitle": "從一開始就擁有全部",
    "proSubtitle": "第一天就擁有全部功能。先免費試用，覺得值得再留下。",
    "proTrust": "沒有廣告，沒有套路，隨時可以取消。",
    "tryProFree": "免費試用 Pro",
    "continueFree": "繼續使用免費方案",
    "allSetTitle": "一切就緒",
    "allSetSubtitle": "歡迎使用 Caliu。讓它成為你的。",
    "startWriting": "開始寫作",
    "firstNoteTitle": "一切從這裡開始",
    "firstNoteBody": "這是我的第一則筆記。它存在這台裝置上，離線也能用，而且到哪裡都跟著我。",
    "firstNoteTask": "寫下一個值得留住的想法",
    "next": "下一步",
    "skip": "略過",
    "back": "返回",
    "intents": {
      "journal": "日記",
      "ideas": "想法",
      "work": "工作",
      "study": "學習",
      "reading": "閱讀",
      "plans": "計畫"
    },
    "signInCta": "登入或建立帳號",
    "continueWithoutAccount": "不使用帳號繼續",
    "backupTitle": "你的筆記住在哪裡",
    "backupSubtitle": "筆記從這台裝置開始。有帳號就會同步，安全的副本會送到你的每一台裝置。",
    "syncOffTitle": "同步已關閉",
    "syncOffBody": "登入後即可在所有裝置上同步筆記。",
    "backupSignedIn": "在你書寫的同時，筆記會被安全同步。",
    "backupStageDevice": "此裝置",
    "backupStageSafe": "已同步",
    "backupStageEverywhere": "所有裝置",
    "freeNotes": "{{limit}} 篇免費筆記，無需帳號，永久有效。Pro 版不限數量。"
  },
  "backup": {
    "evictionNotice": "目前筆記僅儲存在此瀏覽器中。空間不足時，瀏覽器可能會清除網站資料。",
    "dismiss": "關閉",
    "signIn": "登入"
  },
  "gate": {
    "share": "登入後即可分享筆記。",
    "history": "登入後即可保存版本紀錄。",
    "import": "登入後即可匯入筆記。"
  },
  "math": {
    "placeholder": "LaTeX",
    "sourceLabel": "LaTeX 原始碼"
  },
  "noteLimit": {
    "banner": "{{count}} / {{limit}} 篇筆記",
    "paywallTitle": "你已用完 {{limit}} 篇免費筆記",
    "paywallBody": "編輯、搜尋和同步照常可用。把一篇筆記移到垃圾桶即可騰出名額，或升級 Caliu Pro 解除限制：按月、按年，或一次性買斷終身。",
    "importCapped": "只匯入了 {{total}} 個檔案中的 {{count}} 個：免費版最多可保存 {{limit}} 篇筆記。"
  },
  "appUpdate": {
    "available": "Caliu 有新版本可用。"
  },
  "settings": {
    "title": "設定",
    "account": "帳號",
    "writing": "寫作",
    "keyboardShortcuts": "鍵盤快速鍵",
    "editor": "編輯器",
    "yourNotes": "你的筆記",
    "about": "關於",
    "noAccount": "無帳號",
    "sendFeedback": "傳送意見回饋",
    "signInOrCreate": "登入或建立帳號",
    "notesComeWithYou": "此裝置上的筆記會隨你一起轉移。",
    "notSyncing": "未同步",
    "signInToSync": "登入後即可同步筆記。",
    "sync": "同步",
    "security": "安全",
    "communications": "訂閱",
    "newsletter": "Caliu 電子報",
    "newsletterFooter": "偶爾寄一封簡短的郵件，介紹新版本和 Caliu 即將推出的內容。",
    "newsletterError": "無法更新電子報訂閱，請再試一次。",
    "appearance": "外觀",
    "themes": "主題",
    "sizing": "尺寸",
    "systemDefault": "系統預設",
    "separateThemes": "淺色與深色使用不同主題",
    "maxWidth": "最大寬度",
    "maxWidthHint": "在寬螢幕上將正文置中為易讀的欄寬",
    "markdownReturn": "Markdown 風格的 Return",
    "markdownReturnHint": "Return 鍵換行。按兩次 Return 開始新段落",
    "newNoteStart": "新筆記開頭",
    "newNoteStartH1": "標題 1",
    "newNoteStartH2": "標題 2",
    "newNoteStartH3": "標題 3",
    "newNoteStartH4": "標題 4",
    "newNoteStartDate": "日期",
    "newNoteStartDateIso": "日期（ISO 8601）",
    "newNoteStartDateTime": "日期與時間",
    "newNoteStartDateTimeIso": "日期與時間（ISO 8601）",
    "newNoteStartEmpty": "空白",
    "newNoteStartHint": "適用於你在 App 中建立的筆記。",
    "collapsibleSections": "可收合章節",
    "collapsibleSectionsHint": "讓你將標題及其內容收合在箭頭後面",
    "experimental": "實驗性",
    "general": "一般"
  },
  "toolbar": {
    "toggleSidebar": "顯示或隱藏側邊欄",
    "toggleInspector": "切換檢閱器",
    "searchNotes": "搜尋筆記",
    "newNote": "新增筆記",
    "findInNote": "在筆記中尋找",
    "showToolbar": "顯示工具列",
    "hideToolbar": "隱藏工具列",
    "moreNoteActions": "更多筆記操作",
    "undo": "復原",
    "redo": "重做",
    "zenMode": "禪模式",
    "sourceMode": "原始碼模式",
    "richEditor": "豐富文字編輯器",
    "sortBy": "排序方式",
    "bold": "粗體",
    "italic": "斜體",
    "heading": "標題",
    "list": "列表",
    "link": "連結",
    "insert": "插入",
    "more": "更多",
    "strikethrough": "刪除線",
    "table": "表格",
    "horizontalRule": "水平分隔線",
    "codeBlock": "程式碼區塊",
    "inlineCode": "行內程式碼",
    "blockQuote": "引用區塊",
    "math": "公式",
    "highlight": "螢光標示",
    "bulletList": "項目符號列表",
    "orderedList": "編號列表",
    "photoLibrary": "照片圖庫",
    "camera": "相機",
    "files": "檔案",
    "yellow": "黃色",
    "green": "綠色",
    "blue": "藍色",
    "pink": "粉色",
    "purple": "紫色",
    "heading1": "標題 1",
    "heading2": "標題 2",
    "heading3": "標題 3",
    "heading4": "標題 4",
    "heading5": "標題 5",
    "heading6": "標題 6",
    "removeHighlight": "移除螢光標示"
  },
  "whatsNew": {
    "title": "新功能",
    "tagIconsTitle": "為 Caliu 繪製的圖示",
    "tagIconsBody": "App 中的每個圖示都是全新的，專為 Caliu 設計。為每個標籤設定專屬圖示，還能用你的語言搜尋。",
    "newNoteStartTitle": "依你的方式開始筆記",
    "newNoteStartBody": "新筆記可以從標題、今天的日期、日期和時間或一頁空白開始。在「設定」的「編輯器」中選擇。",
    "typographyTitle": "精確設定文字",
    "typographyBody": "在「設定」的「文字排版」中，為筆記選擇精確的文字大小、行高和段落間距。",
    "typographySample": "每則筆記都會按你設定的字級、行高和間距顯示，精確到點。",
    "sampleMorningPages": "晨間隨筆",
    "newsletterTitle": "Caliu 電子報來了",
    "newsletterBody": "從現在起，每次發布都會有一封簡短的電子郵件，用你的語言介紹新功能。想訂閱就打開它。你隨時可以在設定中更改。"
  },
  "sharing": {
    "inviteByEmail": "透過電子郵件邀請",
    "invite": "邀請",
    "roleOwner": "擁有者",
    "roleEditor": "可編輯",
    "roleViewer": "可檢視",
    "generalAccess": "一般存取權",
    "shareWithLink": "透過連結分享",
    "accessRestricted": "僅限受邀者",
    "accessView": "任何擁有連結的人都可檢視",
    "accessEdit": "任何擁有連結的人都可編輯",
    "remove": "移除",
    "leave": "退出",
    "leaveNote": "退出筆記",
    "leaveConfirmTitle": "要退出這則筆記嗎？",
    "leaveConfirmBody": "它會從你所有裝置的列表中消失。擁有者可以再次邀請你。",
    "leaveSelectedTitle": "要退出共享筆記嗎？",
    "leaveSelectedBody_one": "你將退出 {{count}} 則分享給你的筆記。你自己的筆記會移到垃圾桶。",
    "leaveSelectedBody_other": "你將退出 {{count}} 則分享給你的筆記。你自己的筆記會移到垃圾桶。",
    "sharedBy": "由 {{name}} 分享",
    "sharedList": "已分享",
    "viewOnly": "僅檢視",
    "accessNowEditor": "你現在可以編輯這則筆記。",
    "accessNowViewer": "你現在只能檢視這則筆記。",
    "accessRemoved": "你已無法存取這則筆記。",
    "unsentSavedAsCopy": "未傳送的變更已存為副本。",
    "privateNote": "私密筆記",
    "memberLimit": "一則筆記最多可與 50 人分享。",
    "rateLimit": "邀請過多。請稍後再試。",
    "inviteFailed": "無法傳送邀請。請重試。",
    "invalidEmail": "請輸入有效的電子郵件地址。",
    "onlineOnly": "連線到網際網路以管理分享。",
    "you": "你",
    "ownerOnly": "只有擁有者可以變更存取權。",
    "unavailable": "分享功能暫時無法使用。請稍後再試。",
    "updateFailed": "無法更新分享設定。請重試。",
    "inviteInvalid": "此邀請已失效。",
    "copyLink": "複製連結",
    "invited": "已邀請",
    "copied": "已拷貝",
    "accessRestrictedHint": "只有你邀請的人可以打開。",
    "onlyYouHint": "只有你可以開啟。",
    "accessViewHint": "任何擁有連結的人都可以閱讀，無需帳號。",
    "accessEditHint": "任何擁有連結的人都可以編輯。",
    "roleBelowLink": "任何擁有連結的人都可以編輯，所以你邀請的人也可以編輯。",
    "inviteAs": "邀請身分",
    "revokeInvite": "撤銷邀請",
    "statusPeople_one": "{{count}} 人",
    "statusPeople_other": "{{count}} 人",
    "publicLink": "公開連結",
    "statusFrom": "來自 {{name}}",
    "removeConfirmTitle": "要移除 {{name}} 嗎？",
    "removeConfirmBody": "對方將無法再存取這則筆記。",
    "revokeConfirmTitle": "要撤銷寄給 {{name}} 的邀請嗎？",
    "revokeConfirmBody": "邀請連結將失效。",
    "peopleWithAccess": "有權存取的成員",
    "addPeoplePlaceholder": "透過電子郵件新增成員",
    "invitePro": "邀請成員是 Caliu Pro 的功能。",
    "inviteKeepsAccess": "即使關閉連結，受邀的人仍可存取。",
    "youSuffix": "（你）"
  },
  "noAccess": {
    "title": "你沒有這則筆記的存取權限",
    "linkBody": "擁有者沒有與你共享它。請對方邀請你，或開啟它的連結。",
    "signedOutBody": "請用共享時使用的帳號登入。",
    "inviteTitle": "此邀請已失效",
    "inviteBody": "請向邀請你的人索取新的邀請。",
    "removedTitle": "你已無法存取這則筆記",
    "removedBody": "擁有者已將你移除。",
    "removedCopyBody": "擁有者已將你移除。你未傳送的變更已作為副本保留在你的筆記中。",
    "backToNotes": "返回筆記",
    "signIn": "登入"
  }
}
